import React from "react";

/**
 * DebouncedInput is a component that delays the onChange event until the user
 * has stopped typing for a certain amount of milliseconds.
 * @param {String} initialValue
 * @param {Function} onChange
 * @param {Number} [delay=500]
 * @param props
 * @returns {React.ReactNode}
 */
export default function DebouncedInput({initialValue, onChange, delay = 500, ...props}) {
    const [value, setValue] = React.useState(initialValue);
    const timeout = React.useRef(null);
    const handleChange = (value) => {
        setValue(value);
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => onChange(value), delay);
    };
    return <input onChange={(event) => handleChange(event.target.value)}
        value={value} {...props} />;
}
